// FAMILY-EXT: feature header redesign — контейнер пикера проект+доска.
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import ProjectBoardPicker from '../components/ProjectBoardPicker';

const mapStateToProps = (state) => {
  const items = selectors.selectProjectsWithBoardsForCurrentUser(state);
  const { projectId, boardId } = selectors.selectPath(state);
  // FAMILY-EXT: показываем кнопку "Добавить проект" всегда — сервер
  // отдельно проверит права при создании. Раньше gating через
  // allowAllToCreateProjects || isAdmin прятал кнопку, когда config
  // ещё не загружен или isAdmin не пробросился из orm.
  return {
    items,
    currentProjectId: projectId,
    currentBoardId: boardId,
    canAddProject: true,
    // FAMILY-EXT: кнопку "Добавить доску" тоже показываем всегда — права
    // проверит сервер (boards/create.js → users.isProjectManager). Гейт по
    // isManager прятал её у пользователей, которые не менеджеры проекта, и
    // выглядело это как отсутствующая функция. Отказ сервера теперь виден.
    boardCreateError: state.ui.boardCreateForm.error,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onAddProject: entryActions.openProjectAddModal,
      onAddBoard: entryActions.createBoardInProject,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProjectBoardPicker);
